import { LabObservationLevel } from "@/Common/Api/ManualResults/Dtos/LabObservationsDto";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { LabAnalysisModel } from "./LabAnalysisModel";

class ObservationEntryFormData {
    public id: string = GuidHelper.NewGuid();
    public dateTime: Date = new Date();
    public categoryLookupId: string = "";
    public analysis: string = "";
    public referenceLow: string = "";
    public referenceHigh: string = "";
    public result: string = "";
    public units: string = "";
    public flagLookupId: string | null = null;
    public note: string = "";
    public level: LabObservationLevel | null = null;

    private analysisModel: LabAnalysisModel | null = null;

    public get AnalysisModel(): LabAnalysisModel | null {
        return this.analysisModel;
    }

    public set AnalysisModel(model: LabAnalysisModel | null) {
        if (model == null) {
            this.analysisModel = null;
            this.analysis = "";
            this.units = "";
        }
        else {
            this.analysisModel = model;
            this.analysis = model.getId();
            this.units = model.Unit;
        }
    }

    public isValid(): boolean {
        return !!this.analysis && !!this.result && !!this.dateTime;
    }

    public static createEmpty(id?: string): ObservationEntryFormData {
        const result = new ObservationEntryFormData();
        result.id = id ?? GuidHelper.NewGuid();
        return result;
    }

    constructor(model?: Partial<ObservationEntryFormData>) {
        Object.assign(this, model);
    }
}

export { ObservationEntryFormData };
